import OwnershipTypeInput from './OwnershipTypeInput'

export default OwnershipTypeInput
